import { ZonedDateTime } from "@internationalized/date";

export const getAppointmentTypeContext = (appointmentType: string): string => {
  return appointmentType.toLowerCase().replace(/_/g, "-");
};

// --- Date/Time Formatting Utilities ---

const DEFAULT_LOCALE = "en-US";

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  weekday: "short",
  day: "numeric",
  year: "numeric"
};

const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: "numeric",
  minute: "numeric"
};

const ensureDate = (date: Date | ZonedDateTime): Date => {
  if (date instanceof Date) {
    return date;
  }
  return date.toDate();
};

export const formatAppointmentDate = (
  date: Date | ZonedDateTime,
  locale: string = DEFAULT_LOCALE
): string => {
  return ensureDate(date).toLocaleDateString(locale, DATE_FORMAT_OPTIONS);
};

export const formatAppointmentTime = (
  date: Date | ZonedDateTime,
  locale: string = DEFAULT_LOCALE
): string => {
  return ensureDate(date).toLocaleTimeString(locale, TIME_FORMAT_OPTIONS);
};

export const formatAppointmentDateTimeRange = (
  start: Date | ZonedDateTime,
  end: Date | ZonedDateTime,
  locale: string = DEFAULT_LOCALE
): string => {
  const startTime = formatAppointmentTime(start, locale);
  const endTime = formatAppointmentTime(end, locale);
  return `${startTime} – ${endTime}`;
};
